import React from 'react';
import { Col, Management, Row } from 'components';
import { ManagementEditModal } from './edit';
import { useManagement } from './useManagement';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const ClientManagement = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { onAddModalStateChange, managementData, modalState } = useManagement();
  return (
    <Row wrap={false}>
      <Col flex={'566px'}>
        <Management
          hasAccessToEdit={hasAccess(PERMISSIONS.clients.management.write)}
          managementData={managementData}
          onAddModalStateChange={onAddModalStateChange}
        />
      </Col>
      <ManagementEditModal modalState={modalState} onModalStateChange={onAddModalStateChange} />
    </Row>
  );
});
